export default "__VITE_ASSET__Cl3J_2Be__"